import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "./api";
import { mergeGuestWishlistIntoAccount } from "./Wishlist";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/api/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/api/auth/login", { email, password });
      setToken(data.token);
      setUser(data.user);
      await mergeGuestWishlistIntoAccount();   // merge guest wishlist into account
      api.post("/api/auth/_audit-login", { email, success: true, user_agent: navigator.userAgent }).catch(() => {});
      return data.user;
    } catch (e) {
      api.post("/api/auth/_audit-login", { email, success: false, user_agent: navigator.userAgent }).catch(() => {});
      throw e;
    }
  };
  const signup = async (payload) => {
    const { data } = await api.post("/api/auth/signup", payload);
    setToken(data.token);
    setUser(data.user);
    await mergeGuestWishlistIntoAccount();      // merge guest wishlist into account
    return data.user;
  };
  const claimAccount = async (payload) => {
    // Showroom-enrolled customer setting up their login (phone verified by OTP)
    const { data } = await api.post("/api/auth/claim-account", payload);
    setToken(data.token);
    setUser(data.user);
    await mergeGuestWishlistIntoAccount();
    return data.user;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, signup, claimAccount, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth outside provider");
  return ctx;
}
